import { goto } from '$app/navigation';
import { resolve } from '$app/paths';
import { page } from '$app/state';
import type { Path } from '$app/types';

// In-app view (Dashboard / Map / Table) href that keeps the active `?version=` across views.
export function viewHref(path: Path): string {
	const version = page.url.searchParams.get('version');
	return version ? resolve(`${path}?${new URLSearchParams({ version })}`) : resolve(path);
}

export function gotoView(path: Path, opts?: { replaceState?: boolean }): Promise<void> {
	return goto(viewHref(path), opts);
}
